// Estilos para tags e componentes de seleção múltipla
import { injectGlobal } from "@emotion/css";

export const initializeTagStyles = () => {
  injectGlobal`
    /* Estilos para chips/tags */
    .tag-chip {
      display: inline-flex;
      align-items: center;
      border-radius: 0.375rem;
      padding: 0.25rem 0.5rem;
      margin: 0.25rem;
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 500;
      cursor: default;
    }

    .tag-chip .tag-delete {
      margin-left: 0.5rem;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 9999px;
      width: 1.25rem;
      height: 1.25rem;
      transition: background-color 0.2s;
    }

    .tag-chip .tag-delete:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }


    /* Estilos para o dropdown de sugestões */
    .tag-suggestions {
      background-color: white;
      border: 1px solid #e5e7eb;
      border-radius: 0.375rem;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
      max-height: 200px;
      overflow-y: auto;
    }

    .dark .tag-suggestions {
      background-color: #1e293b;
      border-color: #334155;
      z-index: 50;
      margin-top: 0.25rem;
    }

    .tag-suggestion-item {
      padding: 0.5rem 0.75rem;
      cursor: pointer;
    }

    .tag-suggestion-item:hover {
      background-color: #f3f4f6;
    }

    .tag-suggestion-item.active {
      background-color: #f3f4f6;
    }

    /* Estilos para modo escuro */
    .dark .tag-suggestions {
      background-color: #1f2937;
      border-color: #374151;
    }

    .dark .tag-suggestion-item:hover,
    .dark .tag-suggestion-item.active {
      background-color: #374151;
    }

    .dark .tag-chip .tag-delete:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  /* Cores aleatórias para tags */
    .tag-chip.color1 {
      background-color: #e0f2fe;
      color: #0369a1;
    }

    .tag-chip.color2 {
      background-color: #dcfce7;
      color: #166534;
    }

    .tag-chip.color3 {
      background-color: #fef3c7;
      color: #92400e;
    }

    .tag-chip.color4 {
      background-color: #fee2e2;
      color: #991b1b;
    }

    .tag-chip.color5 {
      background-color: #f3e8ff;
      color: #6b21a8;
    }

    .tag-chip.color6 {
      background-color: #fce7f3;
      color: #9d174d;
    }

    .tag-chip.color7 {
      background-color: #e0e7ff;
      color: #3730a3;
    }

    .tag-chip.color8 {
      background-color: #f1f5f9;
      color: #475569;
    }
  `;
};

// Cores disponíveis para atribuição aleatória
const availableColors = [
  'color1',
  'color2',
  'color3',
  'color4',
  'color5',
  'color6',
  'color7',
  'color8'
];

// Cache para armazenar cores já atribuídas a tags
const tagColorCache: Record<string, string> = {};

// Mapeamento de tags para cores (pode ser usado para tags específicas se necessário no futuro)
export const tagColorMap: Record<string, string> = {};

// Função para obter uma cor para uma tag
export const getTagColor = (tag: string): string => {
  // Se a tag já está no mapeamento fixo, retornar a cor definida
  if (tagColorMap[tag]) {
    return tagColorMap[tag];
  }
  
  // Se a tag já tem uma cor no cache, retornar essa cor
  if (tagColorCache[tag]) {
    return tagColorCache[tag];
  }
  
  // Caso contrário, atribuir uma cor aleatória
  // Usamos o hash da string para garantir que a mesma tag sempre receba a mesma cor
  const hashCode = tag.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);
  
  const randomIndex = Math.abs(hashCode) % availableColors.length;
  const randomColor = availableColors[randomIndex];
  
  // Armazenar no cache para uso futuro
  tagColorCache[tag] = randomColor;
  
  return randomColor;
};

